export default () => ({
    listings: {},
});
